module.exports = __webpack_public_path__ + "static/phone-3-dd5b0f9bb85ad0a1837905de3857300a.svg";